import { render } from "./TeamTypeEditDialog.vue?vue&type=template&id=50f6a2ea"
import script from "./TeamTypeEditDialog.vue?vue&type=script&lang=js"
export * from "./TeamTypeEditDialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__